import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { cdnUrl } from '@Utils/cdnHelper';
const PRZLottieT = ({ file, category = 'lotties', loop = true, style = {}, className = '', }) => {
    const [animationData, setAnimationData] = useState(null);
    useEffect(() => {
        const url = cdnUrl(file, category);
        fetch(url)
            .then((res) => {
            if (!res.ok) {
                throw new Error(`Failed to fetch Lottie JSON. Status: ${res.status}`);
            }
            return res.json();
        })
            .then((data) => {
            setAnimationData(data);
        })
            .catch((error) => console.error('Failed to load Lottie:', error));
    }, [file, category]);
    if (!animationData) {
        return null; // 👉 or add a loader/spinner here
    }
    return _jsx(Lottie, { animationData: animationData, loop: loop, style: style, className: className });
};
export default PRZLottieT;
